import { render, staticRenderFns } from "./AttestationJobForm.vue?vue&type=template&id=0907e552&"
import script from "./AttestationJobForm.vue?vue&type=script&lang=js&"
export * from "./AttestationJobForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports